(() => {
  const m=window.MiraiMarket;if(!m)return;
  const dict=window.MiraiTranslations||{}, canonical=new Map(Object.keys(dict).map(k=>[k.toLowerCase(),k]));
  const scopes=(m.locale.split('-')[0]==='he'?'#mirai-advisor-root > .mirai-bubble,':'')+'.collabs-page,.mma,#mirai-routine-wizard,.mirai-bundle,.mrf,.mirai-trust,.trnd,.bspot,.mirai-nl,.brow,.scat,.mrj,.mhome-guide,.mrc,.mirai-collection-hero,.mirai-concerns-directory,.mrcn-wrap,.mr-delivery,.mirai-pdp-delivery,.mirai-selling-plan,.mirai-tiers,.mirai-sample,.announcement-bar,.mirai-upsell,.mq-notif,#ma-global-bar,.ma-global-bar';
  const ignored='script,style,noscript,textarea,input,select,option,code,[data-no-localize],.mrb-product-title,.mrb-summary-name,.mirai-bundle__name,.trnd-title';
  const hebrewAppLabels={"Already a member?":"כבר הצטרפת לתוכנית?","Log in":"כניסה לחשבון","Partnership opportunities":"אפשרויות לשיתוף פעולה","Affiliate marketing":"שיווק שותפים","Discount codes":"קודי הנחה","Campaigns":"קמפיינים","Additional opportunities":"אפשרויות נוספות"};
  function exact(text){const normalized=text.replace(/\s+/g,' ').trim();if(m.locale.split('-')[0]==='he'&&hebrewAppLabels[normalized])return hebrewAppLabels[normalized];const key=canonical.get(normalized.toLowerCase());return key?m.t(key):null;}
  const seen=new WeakMap();
  function translateText(node){
    if(node.parentElement?.closest(ignored))return;
    const value=node.nodeValue;if(!value?.trim()||seen.get(node)===value)return;
    let result=exact(value);
    if(!result){
      const s=value.trim();let match;
      if((match=s.match(/^Step (\d+) of (\d+)$/i)))result=m.t('Step {current} of {total}',{current:match[1],total:match[2]});
      else if((match=s.match(/^Save (\d+)%$/i)))result=m.t('Save {percent}%',{percent:match[1]});
      else if((match=s.match(/^([\d,]+) points$/i)))result=m.t('{points} points',{points:match[1]});
      else if((match=s.match(/^(Silver|Gold|Platinum|Black) Member$/i)))result=m.t('{tier} Member',{tier:m.t(match[1][0].toUpperCase()+match[1].slice(1).toLowerCase())});
      else if((match=s.match(/^(Silver|Gold|Platinum|Black) Benefits$/i)))result=m.t('Benefits')+' · '+m.t(match[1][0].toUpperCase()+match[1].slice(1).toLowerCase());
      else if((match=s.match(/^([\d.,]+)× points on every order$/i)))result=m.t('{multiplier}× points on every order',{multiplier:match[1]});
      else if((match=s.match(/^([\d.,]+)× multiplier unlocks$/i)))result=m.t('{multiplier}× multiplier unlocks',{multiplier:match[1]});
      else if((match=s.match(/^([\d,]+) lifetime pts$/i)))result=m.t('{points} lifetime pts',{points:match[1]});

      else if((match=s.match(/^Shop this routine · (.+)$/)))result=m.t('Shop this routine')+' · '+match[1];
      else if((match=s.match(/^Next billing: (.+)$/)))result=m.t('Next billing: {date}',{date:Number.isNaN(Date.parse(match[1]))?match[1]:new Intl.DateTimeFormat(m.locale,{dateStyle:'medium'}).format(new Date(match[1]))});
    }
    if(result&&result!==value.trim()){node.nodeValue=value.replace(value.trim(),result);seen.set(node,node.nodeValue);}else seen.set(node,value);
  }
  function within(root,selector){
    return [...(root.matches?.(selector)?[root]:[]),...root.querySelectorAll(selector)];
  }
  function localLinks(root){
    within(root,'a[href]').forEach(a=>{
      const href=a.getAttribute('href');
      if(/^\/(products|collections|pages|blogs|policies|apps|cart|search|account)(\/|\?|#|$)/.test(href)){const next=m.url(href);if(next!==href)a.setAttribute('href',next);}
    });
  }
  function localize(root){
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let node;
    while(node=walker.nextNode())translateText(node);
    within(root,'[aria-label]').forEach(el=>{
      const text=el.getAttribute('aria-label');let replacement=exact(text),match;
      if((match=text.match(/^Flip to see (Silver|Gold|Platinum|Black) benefits$/)))replacement=m.t('Flip to see {tier} benefits',{tier:m.t(match[1])});
      if(replacement&&replacement!==text)el.setAttribute('aria-label',replacement);
    });
    localLinks(root);
  }
  window.MiraiLocalize=localize;
  window.MiraiUpdateTiers=(el,total)=>{
    if(window.MiraiShipping?.flat){
      const a=m.convert(Number(el.dataset.tier1)),c=m.convert(Number(el.dataset.tier3));
      if(a===null||c===null||a<=0||c<=a){el.hidden=true;return;}
      el.hidden=false;
      const pct=total>=c?100:total>=a?50+50*(total-a)/(c-a):50*total/a;
      el.querySelector('.mirai-tiers__fill')?.style.setProperty('width',Math.max(0,Math.min(100,pct))+'%');
      for(const [i,amount,label] of [[1,a,'Free sample'],[3,c,'Free gift']]){
        const state=total>=amount?'done':i===1||total>=a?'now':'next';
        const text=el.querySelector('[data-tier-t'+i+']');
        if(text){text.textContent=m.t('{label} at {amount}',{label:m.t(label),amount:m.money(amount)});text.className=state;}
        el.querySelector('[data-node="'+i+'"]')?.setAttribute('data-state',state);
      }
      el.querySelector('[data-node="2"]')?.setAttribute('hidden','');
      el.querySelector('[data-tier-t2]')?.setAttribute('hidden','');
      return;
    }
    const tiers=[1,2,3].map(i=>m.convert(Number(el.dataset['tier'+i])));
    if(tiers.some(v=>v===null||v<=0)){el.hidden=true;return;}
    el.hidden=false;
    const [a,b,c]=tiers;
    let pct=total>=c?100:total>=b?66+33*(total-b)/(c-b):total>=a?33+33*(total-a)/(b-a):33*total/a;
    el.querySelector('.mirai-tiers__fill')?.style.setProperty('width',Math.max(0,Math.min(100,pct))+'%');
    ['Free sample','Free shipping','Free gift'].forEach((label,i)=>{
      const state=total>=tiers[i]?'done':i===0||total>=tiers[i-1]?'now':'next';
      const text=el.querySelector('[data-tier-t'+(i+1)+']');
      const value=m.t('{label} at {amount}',{label:m.t(label),amount:m.money(tiers[i])});
      if(text){if(text.textContent!==value)text.textContent=value;text.className=state;}
      el.querySelector('[data-node="'+(i+1)+'"]')?.setAttribute('data-state',state);
    });
  };
  function shippingMessages(root=document){
    const flat=window.MiraiShipping?.flat;const threshold=m.convert(8000);if(threshold===null&&!flat)return;
    within(root,'.announcement-bar p,.mirai-trust-item').forEach(el=>{
      // Replace known historical $80 announcement only; do not touch prices or percentages.
      if(!(el.matches('[data-mirai-shipping],.mirai-trust-item:nth-child(2)')||/(\$\s*80|80\s*\$|₪\s*500|500\s*₪|80\s*€|€\s*80|80\s*(?:دولار|ดอลลาร์))/.test(el.textContent))||el.dataset.miraiShipping)return;
      let target=el.matches('p')?el:el.querySelector('span');if(!target){target=document.createElement('span');[...el.childNodes].filter(n=>n.nodeType===3).forEach(n=>n.remove());el.append(target);}
      target.textContent=flat?window.MiraiShipping.label:m.t('Free shipping on orders {amount}+',{amount:m.money(threshold)});
      el.dataset.miraiShipping='true';
    });
    within(root,'[data-mirai-tiers]').forEach(el=>window.MiraiUpdateTiers(el,Number(el.dataset.cartTotal)||0));
    within(root,'.mirai-sample[data-threshold]').forEach(el=>{
      const threshold=m.convert(Number(el.dataset.threshold)), total=Number(el.dataset.cartTotal);if(threshold===null){el.hidden=true;return;}
      const unlocked=total>=threshold;
      el.dataset.unlocked=String(unlocked);
      const title=el.querySelector('.mirai-sample__title');if(title)title.textContent=unlocked?m.t('You unlocked a free sample — pick one'):m.t('Spend {amount} more for a free sample',{amount:m.money(threshold-total)});
      el.querySelector('.mirai-sample__grid')?.setAttribute('data-disabled',String(!unlocked));
      el.querySelectorAll('button').forEach(button=>{button.disabled=!unlocked;button.setAttribute('aria-disabled',String(!unlocked));});
    });
  }
  function accountMoney(root=document){
    const shell=root.closest?.('.mma')||root.querySelector('.mma');if(!shell)return;
    shell.querySelectorAll('.sub-card').forEach(card=>{
      card.querySelectorAll('div').forEach(el=>{
        if(el.children.length||el.dataset.miraiMoney)return;
        const match=el.textContent.trim().match(/^Qty: (\d+) · ([\d.]+) ([A-Z]{3})$/);if(!match)return;
        const [_,qty,amount,currency]=match;
        const original=new Intl.NumberFormat(m.locale,{style:'currency',currency}).format(Number(amount));
        const converted=currency===m.shopCurrency?m.convert(Number(amount)*100):null;
        el.textContent=m.t('Qty: {quantity} · {price}',{quantity:qty,price:converted!==null&&currency!==m.currency?'≈ '+m.money(converted)+' ('+original+'; '+m.t('Billed in {currency}',{currency})+')':original});
        el.dataset.miraiMoney='true';
      });
    });
    shell.querySelectorAll('.mma-reward-grid>div>div>div:first-child').forEach(el=>{
      if(el.dataset.miraiMoney)return;
      const match=el.textContent.match(/^\$(\d+) Off$/);if(!match)return;
      const amount=m.convert(Number(match[1])*100);if(amount===null)return;
      el.textContent=(m.currency===m.shopCurrency?'':'≈ ')+m.t('{amount} off',{amount:m.money(amount)});el.dataset.miraiMoney='true';
    });
    shell.querySelectorAll('.mma-rewards strong').forEach(el=>{
      const parent=el.parentElement;
      const text=parent.textContent.trim(),match=text.match(/^([\d,]+) points\s+to (Gold|Platinum|Black)$/);
      if(match)parent.textContent=m.t('{points} points to {tier}',{points:match[1],tier:m.t(match[2])});
    });
    // Loyalty accounting stays in the store's currency; a local estimate is not a new earning rule.
    const how=shell.querySelector('.mma-how');
    if(how&&!how.dataset.miraiMoney){
      const items=how.querySelectorAll('li');
      if(items[0])items[0].textContent=m.t('Earn points based on your order value in {currency}. Your membership tier determines the multiplier.',{currency:m.shopCurrency});
      if(items[2])items[2].textContent=m.t('Exchange points for discounts or gifts at checkout.');
      how.dataset.miraiMoney='true';
    }
    shell.querySelectorAll('.mirai-tier-front').forEach(el=>{
      const label=[...el.querySelectorAll('span')].find(s=>/points per\s*\$1/i.test(s.textContent));
      if(label){const value=m.convert(100);if(value!==null){const row=label.parentElement,multiplier=row.querySelector('span').textContent.replace('×','').trim();row.textContent=m.t('{multiplier}× points per {amount}',{multiplier,amount:(m.currency===m.shopCurrency?'':'≈ ')+m.money(value)});row.style.fontSize='18px';row.style.lineHeight='1.4';}}
    });
  }
  function run(){
    accountMoney();
    document.querySelectorAll(scopes).forEach(localize);
    localLinks(document);
    shippingMessages();accountMoney();
  }
  function boot(){
    if(['he','ar'].includes(m.locale.split('-')[0]))document.documentElement.dir='rtl';
    run();
    // Only revisit changed Mirai components and newly inserted links. Third-party
    // widget text changes must not trigger another walk of the entire page.
    let pending=false;
    const dirty=new Set(),links=new Set();
    const shippingScopes='.announcement-bar,.mirai-trust,[data-mirai-tiers],.mirai-sample';
    function remember(node){
      const el=node.nodeType===1?node:node.parentElement;if(!el)return;
      const parent=el.closest(scopes);if(parent)dirty.add(parent);
      if(node.nodeType===1){
        el.querySelectorAll(scopes).forEach(x=>dirty.add(x));
        links.add(el);
      }
    }
    const observer=new MutationObserver(records=>{
      for(const record of records){
        if(record.type==='characterData')remember(record.target);
        else for(const node of record.addedNodes)remember(node);
      }
      if(pending||(!dirty.size&&!links.size))return;
      pending=true;
      requestAnimationFrame(()=>{
        pending=false;observer.disconnect();
        try{
          const roots=[...dirty].filter(el=>el.isConnected);
          roots.filter(el=>!roots.some(other=>other!==el&&other.contains(el))).forEach(el=>{
            accountMoney(el);localize(el);
            const shipping=el.closest(shippingScopes)||el;
            shippingMessages(shipping);accountMoney(el);
          });
          const added=[...links].filter(el=>el.isConnected);
          added.filter(el=>!added.some(other=>other!==el&&other.contains(el))).forEach(localLinks);
        }finally{
          dirty.clear();links.clear();
          observer.observe(document.body,{childList:true,subtree:true,characterData:true});
        }
      });
    });
    observer.observe(document.body,{childList:true,subtree:true,characterData:true});
    document.addEventListener('cart:updated',event=>{
      const cart=event.detail?.cart;if(!cart||cart.currency!==m.currency)return;
      document.querySelectorAll('[data-mirai-tiers]').forEach(el=>{el.dataset.cartTotal=cart.total_price;window.MiraiUpdateTiers(el,cart.total_price);});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
